module.exports = __webpack_public_path__ + "static/media/5.a3ed795b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/5.jpg
// module id = 58
// module chunks = 0